export default {
  title: 'Testrestaurants',
  description:
    'Elke partner mag één restaurant als testrestaurant markeren. Het werkt als elk ander restaurant en wordt nooit gefactureerd. Er gaat een Slack-melding uit wanneer de verkoop die maand de drempel overschrijdt.',
  empty: 'Geen enkele partner heeft een testrestaurant.',
  columns: {
    partner: 'Partner',
    restaurant: 'Restaurant',
    designated: 'Gemarkeerd als test',
    gmv: 'GMV deze maand',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Opgeschort',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Geen wisselkoers opgeslagen',
  },
  actions: {
    remove: 'Testmarkering verwijderen',
  },
  toasts: {
    load_error: 'De testrestaurants konden niet worden geladen.',
  },
};
